export function createElement(tag, options = {}) {
    const { className, attrs, text, children } = options;
    const node = document.createElement(tag);
    if (className) {
        node.className = className;
    }
    if (attrs) {
        Object.entries(attrs).forEach(([name, value]) => node.setAttribute(name, value));
    }
    if (text !== undefined) {
        node.textContent = text;
    }
    if (children) {
        children.forEach((child) => node.appendChild(child));
    }
    return node;
}

export function createIcon(iconClass) {
    return createElement('i', { className: iconClass, attrs: { 'aria-hidden': 'true' } });
}

export const KEYBOARD_TRAY_ID = 'app-keyboard-tray';

export function isInsideKeyboardTray(node) {
    return node instanceof Element && Boolean(node.closest('#' + KEYBOARD_TRAY_ID));
}
